import React from 'react';
import { Modal } from 'react-bootstrap';
import { CollectorDialogList } from './CollectorDialogList';
import { ConfirmForm } from './ConfirmForm';

export const CollectorDialog = ({ id, show, onHide, status }) => {

    return (
        <Modal
            // size="lg"
            show={show}
            onHide={onHide}
            aria-labelledby="modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="modal-sizes-title-lg">Collect Detail</Modal.Title>
            </Modal.Header>

            <Modal.Body className="overlay overlay-block cursor-default">

                <CollectorDialogList id={id} status={status}/>
                <br/>
                {
                    status === 'REQUEST' && (
                        <ConfirmForm id={id} onHide={onHide}/>
                    )
                }

            </Modal.Body>

        </Modal>
    );
};
